export const CHANGE_INTERNET_STATUS = "CHANGE_INTERNET_STATUS"
export const RECONNECT_TAB = "RECONNECT_TAB";
export const SET_ACTIVE_SESSION_TAB = "SET_ACTIVE_SESSION_TAB";
